import type { Ref } from 'vue'
import { ElMessage } from 'element-plus'
// import { getPrintStyles } from '../utils/css-helper'

interface PrintActionParams {
  printInstance: Ref<any | null>
  printData: Ref<any>
  waitShowPrinter: Ref<boolean>
  callback?: (error?: any) => void
}

interface ExportPDFParams {
  printInstance: Ref<any | null>
  printData: Ref<any>
  download: boolean
  type: string
  fileName: string
  callback?: (status: string, res: any) => void
}

export function usePrintAction() {
  /**
   * 执行打印
   */
  const printAction = ({
    printInstance,
    printData,
    waitShowPrinter,
    callback,
  }: PrintActionParams) => {
    try {
      if (!printInstance.value) {
        ElMessage.error('没有可打印的模板')
        return
      }

      waitShowPrinter.value = true
      printInstance.value.print(
        printData.value,
        {},
        {
          styleHandler: () => {
            // return getPrintStyles()
          },
          callback: () => {
            waitShowPrinter.value = false
            callback?.()
          },
        },
      )
    } catch (error) {
      callback?.(error)
      waitShowPrinter.value = false
    }
  }
  /**
   * 导出pdf
   * @param printData 打印数据
   * @param type 导出类型 [blob, arraybuffer, dataurl, bloburl, dataurlstring, pdfobjectnewwindow]
   * @param fileName 文件名
   * @param download 是否下载
   */
  const exportPDF = ({
    printInstance,
    printData,
    download = true,
    type,
    fileName = '导出文件',
    callback = () => {},
  }: ExportPDFParams) => {
    printInstance.value
      .toPdf(printData.value, fileName, {
        isDownload: download,
        type: type,
      })
      .then((res) => {
        callback('exportSuccess', res)
      })
      .catch((error) => {
        callback('exportError', error)
      })
  }

  return { printAction, exportPDF }
}
